import './sass/styles.scss';

import $ from 'jquery';
import 'jquery-colorbox';


//////////////////
// WEBPACK FOOTER
// ./app/layout.js
// module id = 3
// module chunks = 0